module.exports = __webpack_public_path__ + "img/en-logo.7f781098.png";